import type { NavLinkType } from "@/types/layout-type";
import type { TranslationType } from "@/types/types";

export const navLinks = (t: TranslationType): NavLinkType[] => [
    { label: t("nav.links.home"), path: "" },
    { label: t("nav.links.shop"), path: "/shop" },
    { label: t("nav.links.voucher"), path: "/vouchers" },
    { label: t("nav.links.payment_guide"), path: "/payment-guide" },
    { label: t("nav.links.farm"), path: "/farm" },
    { label: t("nav.links.about"), path: "/about" },
    { label: t("nav.links.contact"), path: "/contact" },
    { label: t("nav.links.tnc", "Syarat & Ketentuan"), path: "/terms-and-conditions" },
];
